import "./Delivery.css";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { useApi } from "../../hooks/ApiProvider";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import Thumbnail from "./Thumbnail";
import DeliveryForm from "./DeliveryForm";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import YesNoPopup from "../YesNoPopup";

export const BtnHeader = ({ ...props }) => {
  console.log(props);
  const { makeBookState, navigate, back, popupShow, noImageYnStatus, onClose } = props;
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();

  // 🎯 X 닫기 버튼 핸들러: 공통 핸들러 사용
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={`btn_header flex items-center justify-between`}>
      {makeBookState > 0 && makeBookState < 4 ? (
        <>
          <button onClick={() => back()} className={`btn btn_back`}></button>
          <button onClick={handleClose} className={`btn btn_close`}></button>
        </>
      ) : (
        <>
          <div></div>
          <button onClick={handleClose} className={`btn btn_close`}></button>
        </>
      )}
    </div>
  );
};

const Delivery = () => {
  const navigate = useNavigate();
  const {
    register,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  let [makeBookState, setMakeBookState] = useState(0);
  // 외부 시스템(예, 네이티브 앱)에서 접근 시 현재 사용하는 액세스 토큰을 로컬스토리지에 저장하고, 로그인 처리를 한다.
  const [forms, setForms] = useState<any>({
    book_id: 0,
    episode_id: 0,
    img_type: ``,
    recipient_name: ``,
    thumb_src: ``,
    phone_num: ``,
    post_num: ``,
    address_1: ``,
    address_2: ``,
  });
  const { getBookCoverStyles, getMyHome, orderPhysicalBook } = useApi();
  const { login } = useMembership();
  const [bookCoverStyles, setBookCoverStyles] = useState<any[]>([]);
  const [bookCoverPopupShow, setBookCoverPopupShow] = useState({
    show: false,
    src: ``,
  });

  // 현재 로그인 사용자의 인터뷰 상태 및 디지털 북 상태를 조회하여, 실물책 신청 가능 여부를 판단한다.
  const [projectInfo, setProjectInfo] = useState<any | null>(null);
  const params = new URLSearchParams(window.location.search);
  // 실물책 신청은, 사요자 소유의 프로젝트 아이디와 그에 속한 디지털북의 아이디를 대상으로 한다.
  // 이 타겟 데이터가 외부 시스템으로 부터 정달되는 경우, 외부 시스템의 프로젝트 아이디와 디지털북 아이디를 타겟으로 한다.
  const [targetProjectId, setTargetProjectId] = useState<number | null>(null);
  const [targetBookId, setTargetBookId] = useState<number | null>(null);
  const [physicalBookOrderAvailable, setPhysicalBookOrderAvailable] = useState<boolean>(false);
  const [popupShow, setPopupShow] = useState(false);
  const [noImageYnStatus, setNoImageYnStatus] = useState<any>(``);

  useEffect(() => {
    const accessTokenFromQuery = params.get("token");
    const projectIdFromQuery = params.get("project_id");
    const bookIdFromQuery = params.get("book_id");
    const localToken = localStorage.getItem("membership_access_token");
    const noImageYn = params.get("noImageYn");
    setNoImageYnStatus(noImageYn || "");

    if (accessTokenFromQuery) {
      if (localToken !== accessTokenFromQuery) {
        localStorage.setItem("membership_access_token", accessTokenFromQuery);
        getMyHome()
          .then((res: any) => {
            const user_profile = res?.user_profile;
            console.log("🚀 ~ Delivery ~ res:", res);
            if (user_profile) {
              console.log("🚀 ~ Delivery ~ user_profile:", user_profile);
              localStorage.setItem("membership_user_profile", JSON.stringify(user_profile));
              login(user_profile, accessTokenFromQuery);
            }

            const project_info = res?.project;
            if (project_info) {
              setProjectInfo(res);
              // 2025-08-20 <- project 오브젝트 -> home 전체 오브젝트로 변경 ("회원정보와 동일"기능 사용 필요)
            }
          })
          .catch((err: any) => {
            console.error("getMyHome 실패:", err);
            localStorage.setItem("membership_access_token", localToken || "");
          });
      } else {
        // 토큰이 동일한 경우에도 projectInfo 로드 시도
        getMyHome()
          .then((res: any) => {
            const project_info = res?.project;
            if (project_info) setProjectInfo(res);
          })
          .catch((err: any) => {
            console.error("기존 토큰으로 getMyHome 실패:", err);
          });
      }
    } else {
      // 외부 시스템이 아닌 웹사용자의 경우, 이미 로그인 되어 있은 토큰으로 현재 프로젝트 정보를 조회한다.
      getMyHome()
        .then((res: any) => {
          const project_info = res?.project;
          if (project_info) setProjectInfo(res);
          // 2025-08-20 <- project 오브젝트 -> home 전체 오브젝트로 변경 ("회원정보와 동일"기능 사용 필요)
        })
        .catch((err: any) => {
          console.error("웹 사용자 getMyHome 실패:", err);
        });
    }
  }, []);

  useEffect(() => {
    getBookCoverStyles().then((res: any) => {
      if (res) {
        console.log(res, "/[res]");
        setBookCoverStyles(res);
      }
    });
  }, []);

  useEffect(() => {
    if (!projectInfo?.project) return;

    if (projectInfo?.project?.id) {
      setTargetProjectId(projectInfo?.project?.id);
    }

    if (projectInfo?.project.books?.length > 0) {
      const book = projectInfo?.project?.books[0];
      if (book?.id) {
        setTargetBookId(book?.id);
      }
    }
  }, [projectInfo]);

  const onHandleStep = async () => {
    console.log(getValues()?.normal);

    if (makeBookState === 4) {
      if (isEmbed()) {
        sendToAndroid("go-to-page", "");
      } else {
        navigate(-1);
      }
      return;
    }

    if (makeBookState === 1) {
      setForms({
        ...forms,
        img_type: getValues()?.normal,
      });
      if (
        getValues()?.normal === "c000" ||
        getValues()?.normal === "c001" ||
        getValues()?.normal === "c002" ||
        getValues()?.normal === "c003"
      ) {
        setMakeBookState(3);
        return;
      }
    }
    makeBookState += 1;
    setMakeBookState(makeBookState);
  };

  const onShowPopup = (url: string) => {
    setBookCoverPopupShow({
      ...bookCoverPopupShow,
      show: true,
      src: url,
    });
  };

  const onFormUpdate = async (type: any, res: any) => {
    if (type === `thumb`) {
      if (res) {
        setForms({ ...forms, thumb_src: res });
      }
    }
    if (type === `delivery`) {
      setForms({
        ...forms,
        ...res,
      });
      console.log(forms, "/[forms---------------->]");

      const orderData = {
        projectId: targetProjectId,
        bookId: targetBookId,
        postalCode: res?.post_num,
        address: res?.address_1,
        addressDetail: res?.address_2,
        recipientName: res?.recipient_name,
        recipientPhone: res?.phone_num,
        image: forms?.thumb_src,
        coverStyleId: forms?.img_type,
      };

      console.log(orderData, "/[orderData---------------->]");

      const result = await orderPhysicalBook(orderData);
      console.log(result, "/[result---------------->]");
    }
    setMakeBookState((makeBookState += 1));
    console.log(res);
  };

  // 🎯 X 닫기 및 네이티브 백버튼 공통 핸들러
  const handleClose = useCallback(() => {
    // makeBookState가 0보다 크면 이전 단계로, 아니면 페이지 닫기
    if (makeBookState > 0) {
      setMakeBookState((prev) => prev - 1);
      return;
    }

    // makeBookState가 0이면 페이지 닫기
    // if (isEmbed()) {
    //   // noImageYnStatus가 존재하고 빈 문자열이 아니면 /mybook으로 이동
    //   if (noImageYnStatus && noImageYnStatus !== "") {
    //     sendToAndroid("go-to-page", "/mybook");
    //   } else {
    //     // 값이 없거나 빈 문자열이면 이전 페이지로 이동 (빈 문자열 = 이전 페이지)
    //     sendToAndroid("go-to-page", "");
    //   }
    // } else {
    // 웹 환경에서는 navigate(-1) 사용
    navigate(-1);
    // }
  }, [makeBookState, noImageYnStatus, isEmbed, navigate, sendToAndroid]);

  // 🎯 Android 네이티브 백버튼 처리 - X 버튼과 동일한 동작
  useEffect(() => {
    const handleNativeBackButton = (event: any) => {
      const eventData = event.detail || event.data;
      if (eventData?.type === "native-back-button") {
        console.log("[Delivery] Native 백버튼 감지 - X 버튼과 동일한 동작");
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
        handleClose();
      }
    };

    // android-event와 message 이벤트 모두 듣기
    window.addEventListener("android-event", handleNativeBackButton, true);
    window.addEventListener("message", handleNativeBackButton, true);

    return () => {
      window.removeEventListener("android-event", handleNativeBackButton, true);
      window.removeEventListener("message", handleNativeBackButton, true);
    };
  }, [handleClose]);

  // console.log(makeBookState,'/[makeBookState---------------->]');
  console.log(forms, "/[forms---------------->]");
  console.log(projectInfo, "/[projectInfo---------------->]");
  // console.log(bookCoverStyles,'/[bookCoverStyles---------------->]');

  return (
    <>
      <div className={`content_wrap delivery`}>
        {makeBookState === 0 && (
          <>
            <div className={`section_wrap sec_wrap_1`}>
              <BtnHeader
                popupShow={popupShow}
                makeBookState={makeBookState}
                navigate={navigate}
                noImageYnStatus={noImageYnStatus}
                onClose={handleClose}
                // back={()=>setMakeBookState(makeBookState - 1)}
              />
              <div className={`sec sec_1 text-center`}>
                <h3 className={`h1`}>현재 책 내용을 실물책으로 인쇄 신청할까요?</h3>
                <h4 className={`h2`}>배송 시작까지 5~7 영업일 정도 걸려요.</h4>
              </div>
              <div className={`sec sec_2 text-center`}>
                <img src={`../contents/book_sample.png`} className={`m-auto`} alt={``} />
              </div>
              <div className={`sec sec_3 text-center`}>
                <div className={`btn_group`}>
                  <button onClick={onHandleStep} className={`btn btn-primary`}>
                    실물책 신청
                  </button>
                </div>
              </div>
            </div>
            <div className={`section_wrap sec_wrap_2`}>
              <div className={`sec`}>
                <p className={`body1 text-[#EB6A36]`}>
                  -신청 후에는 책 내용을 수정할 수 없습니다. 충분히 확인한 후에 신청해주세요.
                </p>
                <p className={`body1`}>
                  -전자책을 인쇄할 수 있도록 편집한 후, 알림톡 및 문자를 통해 최종 확인용 파일을
                  전송해 드립니다
                </p>
              </div>
            </div>
          </>
        )}
        {makeBookState === 1 && (
          <>
            <div className={`section_wrap sec_wrap_3`}>
              <BtnHeader
                makeBookState={makeBookState}
                navigate={navigate}
                noImageYnStatus={noImageYnStatus}
                onClose={handleClose}
                back={() => setMakeBookState(makeBookState - 1)}
              />
              <div className={`sec sec_1 text-center`}>
                <h3 className={`h1`}>책 표지 디자인을 골라주세요.</h3>
              </div>
              <div className={`sec sec_2`}>
                <div
                  className={`flex flex-wrap items-center justify-center max-md:block gap-y-[82px]`}
                >
                  {/**반목문 구간**/}
                  {bookCoverStyles?.map((obj, idx) => {
                    return (
                      <div className={`item_box`} key={idx}>
                        <label className={`img_box`} htmlFor={`normal_${idx}`}>
                          <div className={`relative`}>
                            <img src={obj?.image_url} alt={``} />
                            <button
                              className={`btn btn_zoom`}
                              onClick={() => onShowPopup(obj?.image_full_url)}
                            ></button>
                          </div>
                        </label>
                        <label className={`form_group radio-box`}>
                          <input
                            {...register("normal")}
                            defaultChecked={idx === 0}
                            value={obj?.id}
                            id={`normal_${idx}`}
                            type={`radio`}
                            name={`normal`}
                          />
                          <span className={`circle`}></span>
                          <span className={`label`}>{obj?.name}</span>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={`footer_btn`}>
                <button
                  onClick={onHandleStep}
                  className={`btn btn-primary block w-[100%] rounded-none`}
                >
                  다음
                </button>
              </div>
            </div>
          </>
        )}
        {makeBookState === 2 && ( // 썸네일 지정
          <Thumbnail
            makeBookState={makeBookState}
            navigate={navigate}
            thumbnailSrc={(res: any) => onFormUpdate(`thumb`, res)}
            back={() => setMakeBookState(makeBookState - 1)}
          />
        )}
        {makeBookState === 3 && ( // 배송지 입력
          <DeliveryForm
            projectInfo={projectInfo}
            makeBookState={makeBookState}
            navigate={navigate}
            formData={(res: any) => onFormUpdate(`delivery`, res)}
            back={() => {
              if (
                getValues()?.normal === "c000" ||
                getValues()?.normal === "c001" ||
                getValues()?.normal === "c002" ||
                getValues()?.normal === "c003"
              ) {
                setMakeBookState(makeBookState - 2);
              } else {
                setMakeBookState(makeBookState - 1);
              }
            }}
          />
        )}
        {makeBookState === 4 && ( // 신청완료
          <>
            <div className={`section_wrap sec_wrap_5`}>
              <BtnHeader
                makeBookState={makeBookState}
                navigate={navigate}
                noImageYnStatus={noImageYnStatus}
                onClose={handleClose}
                back={() => setMakeBookState(makeBookState - 1)}
              />
              <div className={`sec sec_1 text-center`}>
                <h3 className={`h1`}>실물책 신청이 완료 되었습니다.</h3>
              </div>
              <div className={`sec sec_2 text-center`}>
                <img src={`../contents/book_sample.png`} className={`m-auto`} alt={``} />
                <p>-진행 단계를 [내 스토리북 현황]에서 확인하실 수 있습니다.</p>
              </div>
              <div className={`footer_btn`}>
                <button
                  onClick={onHandleStep}
                  className={`btn btn-primary block w-[100%] rounded-none`}
                >
                  확인
                </button>
              </div>
            </div>
          </>
        )}
        {bookCoverPopupShow?.show && (
          <div className={`book_cover_popup`}>
            <button
              className={`btn btn-close`}
              onClick={() => setBookCoverPopupShow({ ...bookCoverPopupShow, show: false })}
            ></button>
            <div className={`flex items-center img_box`}>
              <img src={bookCoverPopupShow?.src} alt={`123123`} className={`book_cover_img`} />
            </div>
          </div>
        )}
        {noImageYnStatus === "true" && !popupShow && (
          <>
            <YesNoPopup
              title="아직 등록된 사진이 없어요"
              description="지금 추가해 볼까요?"
              confirmText="사진 추가"
              cancelText="사진 없이 인쇄"
              notifyNative={isEmbed()} // 🎯 모바일 환경에서 네이티브 통신 활성화
              onCancel={() => {
                // 🎯 사진 없이 인쇄: 팝업 종료
                setPopupShow(true);
              }}
              onExit={() => {
                // 🎯 사진 추가: /mybook?openImageModal=true로 이동하여 이미지 모달 자동 열기
                if (isEmbed()) {
                  sendToAndroid("go-to-page", "/mybook?openImageModal=true");
                } else {
                  navigate("/mybook?openImageModal=true");
                }
              }}
            />
          </>
        )}
      </div>
    </>
  );
};
export default Delivery;
